<template>
  <button class="favorite-action" @click="isFavoriteVehicle(id) ? deleteFavoriteVehicle(id) : addFavoriteVehicle(id)">
    <oie-use-svg svg="star-fill" :color="isFavoriteVehicle(id) ? '#006DB6' : '#A2A2A2'"></oie-use-svg>
  </button>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('favorites', ['isFavoriteVehicle'])
  },
  methods: {
    ...mapActions('favorites', ['addFavoriteVehicle', 'deleteFavoriteVehicle'])
  }
}
</script>

<style lang="scss">
.favorite-action {
  @include reset-button;
  width: 1.5rem;
  height: 1.5rem;
  margin-left: measure(half);
  transition: transform 140ms ease;

  &:hover {
    transform: scale(1.2);
    transition: transform 140ms ease;
  }

  > svg {
    width: 100%;
    height: 100%;
  }
}
</style>
